<template>
	<div class="spend">
		<div v-if="storeHydrated">
			<div
				:class='"measuresContainer " + (choosableMeasuresSelectable ? "selectableMeasures" : "unselectableMeasures")'
			>
				<!-- @vue-expect-error -->
				<measure-node
					v-for="measure in availableMeasures"
					:is-selectable="choosableMeasuresSelectable"
					:key="measure.id"
					:measure="measure"
				></measure-node>
			</div>
		</div>
	</div>
</template>

<script>
import MeasureNode from "../measures_components/measure_node.vue";
// Other components
import { i18n } from "../utils";

export default {
	// Naming - server = srv
	mixins: [i18n],
	props: {
		srvAvailableMeasures: Array,
		srvSelectedMeasures: Array,
	},
	components: {
		"measure-node": MeasureNode,
	},
	data: function () {
		return {
			availableMeasures: this.srvAvailableMeasures,
			choosableMeasuresSelectable: true,
		};
	},
	computed: {
		storeHydrated() {
			return (
				VueStore.getters.actorsPropertiesFor(pp.currentActorId) != undefined
			);
		},
		locale: function () {
			return I18n.locale;
		},
	},
	mounted() {
		pp.vue.bus.$on("measure-ENACT", this.onNationalMeasureEnacted);
		pp.vue.bus.$on("choosableMeasuresSelectable", (selectable) => {
			this.choosableMeasuresSelectable = selectable;
		});
	},
	beforeDestroy() {
		pp.vue.bus.$off("measure-ENACT", this.onNationalMeasureEnacted);
	},
	methods: {
		onNationalMeasureEnacted(res) {
			this.availableMeasures = res.available_measures;
		},
	},
};
</script>
